import React from 'react'
import PropTypes from 'prop-types'
import { contentTypeMap } from 'interfaces/contentTypeInterface'
import { getTime, getDate } from 'utils/getTimeDate'
import * as S from './styled'

const EventCard = ({ item, itemHeight, contentType, handleStatus }) => {
  const type = contentType.split('-')
  const itemObject = contentTypeMap(contentType, item)

  return (
    <S.CardContainer itemHeight={itemHeight} contentType={contentType} onClick={() => handleStatus(false)}>
      <S.DateContainer>
        <S.Date contentType={contentType}>
          <S.Month>{getDate(itemObject.date)[0]}</S.Month>
          <S.Day>{getDate(itemObject.date)[1]}</S.Day>
        </S.Date>
        <S.Time contentType={contentType}>
          <S.EventType>{type[0]}</S.EventType>
          <S.EventTime>{getTime(itemObject.time, contentType, item)}</S.EventTime>
        </S.Time>
      </S.DateContainer>
      <S.InfoContainer contentType={contentType}>
        <S.Title>{itemObject.name}</S.Title>
        <S.Description>{itemObject.description}</S.Description>
      </S.InfoContainer>
    </S.CardContainer>
  )
}

EventCard.defaultProps = {
  itemHeight: '',
  handleStatus: () => {},
}

EventCard.propTypes = {
  item: PropTypes.object.isRequired,
  itemHeight: PropTypes.string,
  contentType: PropTypes.string.isRequired,
  handleStatus: PropTypes.func,
}

export default EventCard
